import { render } from "./businessRecords.vue?vue&type=template&id=b1239fea"
import script from "./businessRecords.vue?vue&type=script&lang=js"
export * from "./businessRecords.vue?vue&type=script&lang=js"
script.render = render

export default script